export default {
  color: `
<lol-icon name="setting" color="#DE4561"></lol-icon>
<lol-icon name="delete" color="#3B9CE1"></lol-icon>
<lol-icon name="loading" color="#FFC429"></lol-icon>`,
  loading: `
<lol-icon name="loading" :is-loading="true"></lol-icon>`
}
